import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 根据空运区域获取空运区域港口
export function getListByAirRegion(params) {
  return request({
    url: URL.mdm.basicData.getListByAirRegion,
    method: 'get',
    params
  })
}
